<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="700" persistent :fullscreen="x_mobile">
      <v-card>
        <v-container>
          <v-form ref="form" @submit.prevent="save">
            <v-toolbar flat>
              <v-toolbar-title class="form-dialog-title">{{form_title}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="close()" icon class="float-right">
                <v-icon>mdi-window-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="py-1" v-if="edited_id==-1&&role_name=='Super Admin'">
              <v-row>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-select
                    dense
                    :items="title_item"
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty"
                    v-model="staff_pname"
                    label="คำนำหน้าชื่อ *"
                  ></v-select>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_name"
                    v-model="staff_fname"
                    label="ชื่อ *"
                  ></v-text-field>
                </v-col>

                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_name"
                    v-model="staff_lname"
                    label="นามสกุล *"
                  ></v-text-field>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                    v-model="staff_code"
                    label="รหัสเจ้าหน้าที่"
                  ></v-text-field>
                </v-col>

                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                    v-model="staff_position"
                    label="ตำแหน่ง"
                  ></v-text-field>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_tel"
                    v-model="staff_phone"
                    v-mask="'###-###-####'"
                    label="เบอร์โทร *"
                  ></v-text-field>
                </v-col>

                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_email"
                    v-model="staff_email"
                    label="อีเมล *"
                  ></v-text-field>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_user"
                    v-model="staff_username"
                    label="บัญชีผู้ใช้ *"
                  ></v-text-field>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-text-field dense readonly value="ส่งไปยังอีเมล" label="รหัสผ่าน"></v-text-field>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:4" class="py-1">
                  <v-select
                    dense
                    :items="role_item"
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:empty"
                    v-model="staff_role_id"
                    item-text="role_name"
                    item-value="role_id"
                    label="สิทธิ์การเข้าถึง"
                  ></v-select>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xsOnly?12:8" class="py-1">
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_ps"
                    v-model="staff_ps"
                    label="หมายเหตุ"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="py-1" v-if="edited_id!=-1">
              <v-row>
                <v-col cols="12" v-if="role_name=='Super Admin'">
                  <v-btn
                    v-if="role_name=='Super Admin'"
                    class="float-right"
                    @click="mode='edit'"
                    v-show="mode!='edit'"
                    x-small
                    outlined
                  >
                    แก้ไข
                    <v-icon x-small class="ml-1">fas fa-pencil-alt</v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-select
                    :readonly="(mode != 'edit' && edited_id > -1)"
                    :disable="(mode != 'edit' && edited_id > -1)"
                    dense
                    :items="title_item"
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty"
                    v-model="staff_pname"
                    label="คำนำหน้าชื่อ *"
                  ></v-select>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_name"
                    label="ชื่อ *"
                    v-model="staff_fname"
                    :readonly="mode==''"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_name"
                    label="นามสกุล *"
                    v-model="staff_lname"
                    :readonly="mode==''"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    :readonly="mode==''"
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                    label="รหัสเจ้าหน้าที่"
                    v-model="staff_code"
                    :disabled="mode!='edit'&&edited_id!=-1&&staff_code==''"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    :readonly="mode==''"
                    :disabled="mode!='edit'&&edited_id!=-1&&staff_position==''"
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                    label="ตำแหน่ง"
                    v-model="staff_position"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    :readonly="mode==''"
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_tel"
                    label="เบอร์โทร *"
                    v-mask="'###-###-####'"
                    v-model="staff_phone"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_email"
                    label="อีเมล *"
                    v-model="staff_email"
                    :readonly="mode==''"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:4"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-select
                    :readonly="mode!='edit'"
                    dense
                    :items="role_item"
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:empty"
                    v-model="staff_role_id"
                    item-text="role_name"
                    item-value="role_id"
                    label="สิทธิ์การเข้าถึง"
                  ></v-select>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.xsOnly?12:12"
                  class="py-1"
                  :class="mode=='edit'?null:'hide_input_line'"
                >
                  <v-text-field
                    dense
                    :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_ps"
                    label="หมายเหตุ"
                    v-model="staff_ps"
                    :readonly="mode==''"
                    :disabled="mode!='edit'&&edited_id!=-1&&staff_ps==''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions :class="$vuetify.breakpoint.xsOnly?'px-3 py-0':'py-0 px-8'">
              <v-switch
                v-show="edited_id >-1"
                :disabled="mode==''&&mode!='edit'&&edited_id!=-1"
                v-model="switch_status"
                color="green"
              ></v-switch>
              <span
                v-show="edited_id >-1"
                class="ml-2"
              >{{switch_status==true?'พนักงานปกติ':'พ้นสภาพ'}}</span>
              <v-spacer></v-spacer>
              <v-btn
                v-if="role_name=='Super Admin'"
                @click="canCel()"
                color="secondary"
                small
                outlined
                v-show="edited_id!=-1&&mode=='edit'"
              >ยกเลิก</v-btn>
              <v-btn
                v-if="role_name=='Super Admin'"
                :loading="btn_loading"
                color="button"
                dark
                v-show="edited_id==-1||mode=='edit'"
                type="submit"
                small
              >บันทึก</v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
// import { mask } from "vue-the-mask";
import { rules } from "../assets/js/validate";
export default {
  // directives: {
  //   mask,
  // },
  data() {
    return {
      role_name: this.$session.get("role"),
      btn_loading: false,
      // mask
      // mobile_mask: "###-###-####",
      title_item: ["นาย", "นาง", "นางสาว"],
      header_token: { headers: { token: this.$session.get("token") } },
      dialog: false,
      edited_id: -1,
      mode: "",
      role_data: [],
      rule_staff_user: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) =>
          /^[A-Za-z0-9._-]+$/.test(v) ||
          "ต้องเป็นภาษาอังกฤษ ตัวเลขและ . - _ เท่านั้น",
        (v) => (!!v ? v.length >= 3 : false) || "ต้องความยาวอย่างน้อย 3 ตัว",
        (v) => (!!v ? v.length <= 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
      ],
      rule_staff_name: rules.staff_name_rules,
      rule_staff_position: [
        // v => (v ? v.length <= 50 : false) || "ข้อความมีความยาวมากเกินไป"],
        (v) => (v != "" ? v[0] != " " : true) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        (v) =>
          (v != null ? v.length <= 50 : true) || "ข้อความมีความยาวมากเกินไป",
      ],
      rule_staff_ps: rules.staff_ps_rules,
      rule_empty: rules.empty,
      empty: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      no_rules: [(v) => (!!v ? true : true || "")],
      rule_tel: [
        (v) => !!v || "กรุณากรอกหมายเลขโทรศัพท์",
        (v) => /^[0-9+-]+$/.test(v) || "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
        (v) =>
          (!!v ? v.length == 11 || v.length == 12 : false) ||
          "กรุณากรอกหมายเลขโทรศัพท์ 9-10 หลัก",
        // v => v.length >= 11 || "กรุณากรอกหมายเลขโทรศัพท์ 9 หลัก",
        (v) =>
          (v[0] ? v[0] == "0" : true) || "เบอร์โทรศัพท์ต้องขึ้นต้นด้วยเลข '0'",
      ],
      rule_email: rules.email_rules,
      old_switch_status: true,
      switch_status: true,

      ///////////////////////////
      staff_role_id: 2,
      staff_username: "",
      staff_password: "",
      staff_pname: "",
      staff_fname: "",
      staff_lname: "",
      staff_email: "",
      staff_phone: "",
      staff_code: "",
      staff_position: "",
      staff_ps: "",

      /////////////////////////////
      ///////////////////////////
      old_staff_role_id: 0,
      old_staff_username: "",
      old_staff_password: "",
      old_staff_pname: "",
      old_staff_fname: "",
      old_staff_lname: "",
      old_staff_email: "",
      old_staff_phone: "",
      old_staff_code: "",
      old_staff_position: "",
      old_staff_ps: "",

      /////////////////////////////

      profile: {},
    };
  },
  computed: {
    form_title() {
      return this.edited_id == -1
        ? "เพิ่มเจ้าหน้าที่"
        : this.edited_id != -1 && this.mode == "edit"
        ? "แก้ไขเจ้าหน้าที่"
        : "รายละเอียดเจ้าหน้าที่";
    },
    x_mobile() {
      if (this.$vuetify.breakpoint.width <= 415) {
        return true;
      } else {
        return false;
      }
    },
    role_item() {
      let items = this.role_data;
      return items;
    },
  },
  created() {
    this.getRole();
  },
  watch: {
    staff_username(val) {
      // this.$refs.form_username.resetValidation();
      clearTimeout(this.check_already_settimeout);
      this.check_already_settimeout = setTimeout(() => {
        if (val != "" && this.edited_id < 0 && val.length >= 3) {
          this.checkAlreadyUsername();
        }
      }, this.check_already_delay);
    },
    staff_email(val) {
      // this.$refs.form_username.resetValidation();
      clearTimeout(this.check_already_settimeout);
      this.check_already_settimeout = setTimeout(() => {
        if (val != "" && val != this.old_staff_email) {
          this.checkAlreadyEmail();
        }
      }, this.check_already_delay);
    },
  },
  methods: {
    open(item) {
      this.dialog = true;
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      // console.log(item);
      if (item != "") {
        if (item.staff_id >= 0) {
          this.edited_id = item.staff_id;
          this.mode = "";

          // email_from: "",
          this.staff_role_id = item.role_id;
          this.staff_username = item.username;
          this.staff_password = item.password;
          this.staff_pname = item.pname;
          this.staff_fname = item.fname;
          this.staff_lname = item.lname;
          this.staff_email = item.email;
          this.staff_phone = item.phone;
          this.staff_code = item.staff_code == null ? "" : item.staff_code;
          this.staff_position = item.position == null ? "" : item.position;
          this.staff_ps = item.ps == null ? "" : item.ps;

          this.old_staff_role_id = item.role_id;
          this.old_staff_username = item.username;
          this.old_staff_password = item.password;
          this.old_staff_pname = item.pname;
          this.old_staff_fname = item.fname;
          this.old_staff_lname = item.lname;
          this.old_staff_email = item.email;
          this.old_staff_phone = item.phone;
          this.old_staff_code = item.staff_code == null ? "" : item.staff_code;
          this.old_staff_position = item.position == null ? "" : item.position;
          this.old_staff_ps = item.ps == null ? "" : item.ps;

          this.switch_status = item.status;
          this.old_switch_status = item.status;
        }
      } else {
        this.edited_id = -1;
        this.mode = "";
        this.staff_role_id = 2;
        this.staff_username = "";
        this.staff_password = "";
        this.staff_pname = "";
        this.staff_fname = "";
        this.staff_lname = "";
        this.staff_email = "";
        this.staff_phone = "";
        this.staff_code = "";
        this.staff_position = "";
        this.staff_ps = "";
        setTimeout(() => {
          this.$refs.form.resetValidation();
        }, 50);
        this.switch_status = true;
      }
    },
    checkAlreadyUsername() {
      let data = {
        username: this.staff_username,
      };

      this.axios
        .post(
          process.env.VUE_APP_API + "/api/v1/staff/check_username",
          data,
          this.header_token
        )
        .then((response) => {
          if (response.data.status != "OK" && response.data.status == "FAIL") {
            this.rule_staff_user = [
              (v) => !!v || "กรุณากรอกข้อมูล",
              (v) =>
                /^[A-Za-z0-9._-]+$/.test(v) ||
                "ต้องเป็นภาษาอังกฤษ ตัวเลขและ . - _ เท่านั้น",
              (v) =>
                (!!v ? v.length >= 3 : false) || "ต้องความยาวอย่างน้อย 3 ตัว",
              (v) =>
                (!!v ? v.length <= 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
              (v) => false || "ชื่อผู้ใช้งานนี้ถูกใช้ไปแล้ว",
            ];
          } else {
            this.rule_staff_user = [
              (v) => !!v || "กรุณากรอกข้อมูล",
              (v) =>
                /^[A-Za-z0-9._-]+$/.test(v) ||
                "ต้องเป็นภาษาอังกฤษ ตัวเลขและ . - _ เท่านั้น",
              (v) =>
                (!!v ? v.length >= 3 : false) || "ต้องความยาวอย่างน้อย 3 ตัว",
              (v) =>
                (!!v ? v.length <= 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
            ];
          }
        });
    },
    checkAlreadyEmail() {
      this.rule_email = [
        (v) => !!v || "กรุณากรอกอีเมล",
        (v) => /.+@.+\.+/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+([A-Za-z])+$/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => !/([ก-๏ ])/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => (!!v ? v.length <= 100 : false) || "ข้อความมีความยาวมากเกินไป",
      ];

      let data = {
        email: this.staff_email,
      };

      this.axios
        .post(
          process.env.VUE_APP_API + "/api/v1/staff/check_email",
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response);
          if (response.data.status != "OK" && response.data.status == "FAIL") {
            this.rule_email = [
              (v) => !!v || "กรุณากรอกอีเมล",
              (v) => /.+@.+\.+/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) =>
                /.+@.+\.+([A-Za-z])+$/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) => !/([ก-๏ ])/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) =>
                (!!v ? v.length <= 100 : false) || "ข้อความมีความยาวมากเกินไป",
              (v) => false || "อีเมลนี้ถูกใช้ไปแล้ว",
            ];
          } else {
            this.rule_email = [
              (v) => !!v || "กรุณากรอกอีเมล",
              (v) => /.+@.+\.+/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) =>
                /.+@.+\.+([A-Za-z])+$/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) => !/([ก-๏ ])/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
              (v) =>
                (!!v ? v.length <= 100 : false) || "ข้อความมีความยาวมากเกินไป",
            ];
          }
        });
    },
    canCel() {
      this.staff_role_id = this.old_staff_role_id;
      this.staff_username = this.old_staff_username;
      this.staff_password = this.old_staff_password;
      this.staff_pname = this.old_staff_pname;
      this.staff_fname = this.old_staff_fname;
      this.staff_lname = this.old_staff_lname;
      this.staff_email = this.old_staff_email;
      this.staff_phone = this.old_staff_phone;
      this.staff_code = this.old_staff_code;
      this.staff_position = this.old_staff_position;
      this.staff_ps = this.old_staff_ps;
      this.switch_status = this.old_switch_status;
      this.mode = "";
    },
    close() {
      this.edited_id = -1;
      this.mode = "";
      this.staff_role_id = 2;
      this.staff_username = "";
      this.staff_password = "";
      this.staff_pname = "";
      this.staff_fname = "";
      this.staff_lname = "";
      this.staff_email = "";
      this.staff_phone = "";
      this.staff_code = "";
      this.staff_position = "";
      this.staff_ps = "";
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.switch_status = true;
      this.btn_loading = false;
      this.dialog = false;
    },
    save() {
      this.profile = this.$session.get("profile");
      if (this.$refs.form.validate()) {
        if (this.edited_id > -1) {
          if (this.switch_status == false && this.old_switch_status == true) {
            this.$swal
              .fire({
                // text: "ยืนยันการลบ?",
                text:
                  "หากปรับเป็นสถานะพ้นสภาพแล้ว เจ้าหน้าที่จะไม่สามารถเข้าสู่ระบบได้อีก ยืนยันรายการดังนี้หรือไม่",
                icon: "warning",
                width: 500,
                showCancelButton: true,
                confirmButtonColor: "#E53935",
                cancelButtonColor: "#9E9E9E",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((res) => {
                if (res.value) {
                  this.btn_loading = true;
                  this.putStaff(this.edited_id);
                }
              });
          } else {
            this.btn_loading = true;
            this.putStaff(this.edited_id);
          }
        } else {
          this.btn_loading = true;
          this.postStaff();
        }
      } else {
      }
    },
    postStaff() {
      let data = {
        email_from: this.profile.email,
        role_id: this.staff_role_id,
        username: this.staff_username,
        password: this.staff_password,
        pname: this.staff_pname,
        fname: this.staff_fname,
        lname: this.staff_lname,
        email: this.staff_email,
        phone: this.staff_phone,
        staff_code: this.staff_code == "" ? null : this.staff_code,
        position: this.staff_position == "" ? null : this.staff_position,
        ps: this.staff_ps == "" ? null : this.staff_ps,
        status: 0,
      };

      // console.log(data);
      this.axios
        .post(
          process.env.VUE_APP_API + "/api/v1/staff",
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data.result);
          if (response.data.status == "OK" && response.data.status != "FAIL") {
            this.$swal.fire({
              icon: "success",
              width: 500,
              title: response.data.message,
              text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
            this.close();
            this.$emit("getstaff", "add");
          } else {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: response.data.message,
              text: "กรุณาตรวจสอบข้อมูลของท่าน",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
            this.close();
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            width: 500,
            title: "เกิดข้อผิดพลาด",
            showConfirmButton: false,
            timer: 2000,
            showCloseButton: true,
          });
        });
    },
    putStaff(id) {
      // this.staff.email_from = this.profile.email;
      let data = {
        email_from: this.profile.email,
        role_id: this.staff_role_id,
        username: this.staff_username,
        // password: this.staff_password,
        pname: this.staff_pname,
        fname: this.staff_fname,
        lname: this.staff_lname,
        email: this.staff_email,
        phone: this.staff_phone,
        staff_code: this.staff_code == "" ? null : this.staff_code,
        position: this.staff_position == "" ? null : this.staff_position,
        ps: this.staff_ps == "" ? null : this.staff_ps,
        status: this.switch_status == true ? 1 : 0,
      };

      // console.log(data);
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/staff/" + id,
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data.result);
          if (response.data.status == "OK" && response.data.status != "FAIL") {
            this.$swal.fire({
              icon: "success",
              width: 500,
              title: response.data.message,
              text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
            this.close();
            this.$emit("getstaff", "edit");
          } else {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: response.data.message,
              text: "กรุณาตรวจสอบข้อมูลของท่าน",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            width: 500,
            title: "เกิดข้อผิดพลาด",
            showConfirmButton: false,
            timer: 2000,
            showCloseButton: true,
          });
        });
    },
    getRole() {
      let data = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/role", this.header_token)
        .then((response) => {
          // console.log(response.data.result);
          if (response.data.result && response.data.status == "OK") {
            data = response.data.result;
            this.role_data = data;
          }
        });
    },
  },
};
</script>
